import { Component, Injectable, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/primeng';
import { Location } from '@angular/common';
import { Subject } from 'rxjs/Rx';
import { EvsStoreService } from '../../../../common/services/EvsStore.service';
import { PagerService } from '../../../../common/services/Pagination.service';
import { ModalInfoService } from '../../../../common/services/ModalInfo.service';
import { DownloadExcelService } from '../../../../common/services/DownloadExcel.service';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { StoreExcelComponent } from '../../../../common/helper/evs/store/store.excel.component';
import { EvsUserService } from '../../../../common/services/EvsUser.service';
import { ToastrService } from 'ngx-toastr';

import * as _ from 'lodash';
import { environment } from '../../../../../environments/environment';
import * as moment from 'moment'
import { ExportService } from '../../../../common/services/Export.service';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'store_list',
  templateUrl: './store-list-detail.template.html',
  styleUrls: ['../../../../../css/fuck.css', './store-list-detail.component.css'],
  providers: [ConfirmationService, EvsStoreService, DownloadExcelService, EvsAddressService, EvsUserService, ToastrService]
})

@Injectable()
export class StoreListComponent implements OnInit {
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();
  public currentPage: number = 1;
  public totalRow: number = 0;
  public page_size: number = 10;
  public pager: any = {};
  public message: { class: string, content: string } = null;
  public msgs: Message[] = [];
  public error: string = '';
  public componentData = null;
  public routerChange: any;
  public model: any = {};
  public stores: any = [];
  public paramsQuery: any = {};

  public cities: Array<any> = [];
  public districts: Array<any> = [];

  public current_filter: any = {};
  public item_active: any = 0;
  public item_detail: any = {};
  loading_data = true;

  isSorting: any = {};
  isAdd: Boolean = false;
  isUpdate: Boolean = false;

  lat: number = 21.0286669;
  lng: number = 105.8521485;

  zoom: number = 15;
  isShowLocation: Boolean = false;
  listStaff: any = [];

  /***Tuanba:17-11-2022: Thay api xuất báo cáo **/
  public messageExport = '';

  listType = [
    { id: 1, value: 1, label: 'Điểm bán' },
    { id: 2, value: 2, label: 'Bảo hành' },
    { id: 3, value: 3, label: 'Điểm bán + Bảo hành' }
  ];
  totalItem: any = 0;
  totalStores: any = 0;
  totalActive: any = 0;
  totalHidden: any = 0;
  totalPage: any = 0;

  constructor(private _location: Location,
    private router: Router,
    private storeService: EvsStoreService,
    private pagerService: PagerService,
    public addressService: EvsAddressService,
    private mdInfo: ModalInfoService,
    private activatedRoute: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private toastr: ToastrService,
    private userService: EvsUserService,
    private exportService: ExportService,
    public translate: TranslateService
  ) {
  }

  ngOnInit() {
    $('[data-toggle="tooltip"]').tooltip();
    let that = this;
    let province = $('#province');
    let district = $('#district');
    let staff = $('#staff');

    // Initial translation
    this.translate.get([
      'CHON_TINHTP', 'CHON_QUANHUYEN', 'CHON_TRANG_THAI', 'CHON_NHA_VIEN'
    ]).subscribe(res => {
      $('#status').select2({ placeholder: res['CHON_TRANG_THAI'], allowClear: true, minimumResultsForSearch: Infinity });
      province.select2({ placeholder: res['CHON_TINHTP'], allowClear: false });
      district.select2({ placeholder: res['CHON_QUANHUYEN'], allowClear: false });
      staff.select2({ placeholder: res['CHON_NHA_VIEN'], allowClear: false });
    });

    // Listen to language changes
    this.translate.onLangChange.subscribe(() => {
      this.translate.get([
        'CHON_TINHTP', 'CHON_QUANHUYEN', 'CHON_TRANG_THAI', 'CHON_NHA_VIEN'
      ]).subscribe(res => {
        $('#status').select2({ placeholder: res['CHON_TRANG_THAI'], allowClear: true, minimumResultsForSearch: Infinity });
        province.select2({ placeholder: res['CHON_TINHTP'], allowClear: false });
        district.select2({ placeholder: res['CHON_QUANHUYEN'], allowClear: false });
        staff.select2({ placeholder: res['CHON_NHA_VIEN'], allowClear: false });
      });
    });
    province.on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
      let id = e.target.value;
      that.loadDistrictData(id);
    });
    district.on('select2:select', function () {
      $('.select2-selection__rendered').removeAttr('title');
    });
    $('#inputStart').datepicker({ format: 'dd-mm-yyyy' });
    $('#inputEnd').datepicker({ format: 'dd-mm-yyyy' });
    $('.input-daterange').datepicker();

    // this.clearDataForm();
    this.getCity();
    this.getStaffList();
    //this.loadData();
    this.setSort('created_at', 'desc');
    this.isSorting['field'] = 'created_at';
    this.isSorting['typeSort'] = 'desc';
    // if ($(window).width() <= 1280) {
    //     $('#item-filter').css({ 'margin-top': '5px' })
    // }
    // $(window).resize(() => {
    //     if ($(window).width() <= 1280) {
    //         $('#item-filter').css({ 'margin-top': '5px' })
    //     } else {
    //         $('#item-filter').css({ 'margin-top': '0px' })
    //     }
    // })
  }

  getStaffList() {
    this.userService
      .getEmployees({ desc: 'id' })
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          this.listStaff = res.data.staffs;
          let listStaff: any = [];
          let master: any = res.data.master
          if (master) {
            listStaff.push({
              id: master.id,
              name: master.name
            });
          }
          for (let i = 0; i < this.listStaff.length; i++) {
            listStaff.push({
              id: this.listStaff[i].id,
              name: this.listStaff[i].name
            });
          }
          this.listStaff = listStaff;
        }
      });
  }

  getCity() {
    this.addressService.getCities().subscribe(res => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  loadDistrictData(id: number) {
    this.addressService.getDistrict({ city_id: id }).toPromise().then(res => {
      let districts = [];
      res.data.districts.forEach((c: any) => {
        districts.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.districts = districts;
    })
  }

  loadData(request: any = {}, sort: any = {}) {
    this.stores = [];
    this.loading_data = true;
    if (_.isEmpty(request)) {
      request = this.current_filter;
    }

    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    request.deleted = 0;
    delete request.desc;
    delete request.asc;
    if (Object.keys(sort).length == 0) {
      request[this.isSorting['typeSort']] = this.isSorting['field']
    } else {
      request[sort.typeSort] = sort.field;
    }
    this.storeService.getAll(request).toPromise().then(res => {
      this.loading_data = false;
      // console.log('store: ', res);
      if (res.status == 200 && res.error == false) {
        this.totalRow = res.data.total;
        this.stores = res.data.store;
        this.totalItem = res.data.count.total;
        this.totalStores = res.data.count.count_store;
        this.totalActive = res.data.count.count_active;
        this.totalHidden = res.data.count.count_hidden;

        let pageString = (this.totalItem / this.page_size).toString();
        let pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++
          }
        }
        this.totalPage = totalpage;

        if (this.stores.length > 0) {

          // for (let i = 0; i < this.stores.length; i++) {
          //     for (let c = 0; c < this.cities.length; c++) {
          //         if (this.stores[i].province === this.cities[c].id) {
          //             this.stores[i].province = this.cities[c].value;
          //             this.addressService.getDistrict({ city_id: this.cities[c].id }).toPromise().then(resDistrict => {
          //                 let districts = resDistrict.data.districts;
          //                 for (let d = 0; d < districts.length; d++) {
          //                     if (this.stores[i].district === districts[d].id) {
          //                         this.stores[i].district = districts[d].name;
          //                     }
          //                 }
          //             })
          //         }
          //     }
          // }

          this.item_detail = this.stores[this.item_active];
          if (this.item_detail.latitude && this.item_detail.longitude) {
            this.isShowLocation = true;
            this.zoom = 15;
            this.lat = parseFloat(this.item_detail.latitude);
            this.lng = parseFloat(this.item_detail.longitude);
          } else {
            this.zoom = 10;
          }
        }
        //this.setPage(this.currentPage);
      } else {
        this.message = {
          class: 'alert dark alert-danger',
          content: res.status + ' : ' + res.message
        };
        this.stores = [];
        // this.genDataTable();
        this.scrollToTop();
      }

    }, err => {
      this.message = {
        class: 'alert dark alert-danger',
        content: err.message
      };
      this.stores = [];
      // this.genDataTable();
      this.scrollToTop();
    });
  }

  viewDetail(i) {
    this.lat = 21.0286669;
    this.lng = 105.8521485;
    this.isShowLocation = false;
    if (this.isAdd == true) {
      this.toastr.info(this.translate.instant('HUY_TAO_MOI_CUA_HANG'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
    if (this.isUpdate == true) {
      this.toastr.info(this.translate.instant('HUY_CAP_NHAT_CUA_HANG'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
    this.isAdd = false;
    this.isUpdate = false;
    this.item_active = i;
    this.item_detail = this.stores[i];
    if (this.item_detail.latitude && this.item_detail.longitude) {
      this.isShowLocation = true;
      this.zoom = 15;
      this.lat = parseFloat(this.item_detail.latitude);
      this.lng = parseFloat(this.item_detail.longitude);
    } else {
      this.zoom = 10;
    }
    //console.log(this.lat, this.lng)
  }


  handleUpdated(event) {
    if (event) {
      this.loadData(this.paramsQuery);
    }
  }

  uploadExcel() {
    this.componentData = {
      component: StoreExcelComponent,
      inputs: {
        size: 'modal-md'
      }
    };
  }

  resetForm(frm: NgForm) {
    $('#province').val('').trigger('change');
    $('#district').val('').trigger('change');
    $('#staff').val('').trigger('change');
    this.districts = [];
    // $('#type').val('').trigger('change');
    $('#status').val('').trigger('change');
    frm.reset();
    this.onSubmit();
  }

  onSubmit() {
    this.item_active = 0;
    let modelQuery = <any>{};
    if (this.model.name) {
      modelQuery.name = this.model.name;
    }
    // let type_value = $('#type').val();
    // if (type_value) {
    //   modelQuery.type = type_value.toString();
    // }
    if ($('#province').val()) {
      let city = $('#province option:selected').val();
      modelQuery.province = city.trim();
    }
    if ($('#district').val()) {
      let district = $('#district option:selected').val();
      modelQuery.district = district.trim();
    }
    if ($('#staff').val()) {
      let staff = $('#staff option:selected').val();
      modelQuery.created_id = staff.trim();
    }
    if (this.model.created_time) {
      modelQuery.from = moment(this.model.created_time[0]).startOf('day')['_d'];
      modelQuery.to = moment(this.model.created_time[1]).endOf('day')['_d'];
    }
    let status_value = $('#status').val();
    if (status_value) {
      modelQuery.status = status_value;
    }

    this.currentPage = 1;
    this.current_filter = modelQuery;
    this.loadData(modelQuery)
  }

  delete(id) {
    this.confirmationService.confirm({
      message: this.translate.instant('BAN_CHAC_CHAN_MUON_XOA'),
      header: this.translate.instant('XAC_NHAN'),
      icon: 'fa fa-trash',
      accept: () => {
        this.storeService.deleteById(id).subscribe(response => {
          if (response) {
            let mEror = response.error;

            if (mEror === false) {
              // this.msgs = [{
              //     severity: 'success',
              //     summary: 'Thông báo',
              //     detail: 'Xóa thành công'
              // }];
              this.toastr.success(this.translate.instant('XOA_THANH_CONG'), '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
              });
            } else {
              // this.msgs = [{
              //     severity: 'error',
              //     summary: 'Thông báo',
              //     detail: 'Không thành công: ' + response.message
              // }];
              this.toastr.error(response.message, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
              });
            }
            this.loadData(this.paramsQuery);
          }
        });
      }
    });
  }


  checkAll() {
    if ($('#td-checkbox-main').is(':checked')) {
      $('input.td-checkbox').prop('checked', true);
    } else {
      $('input.td-checkbox').prop('checked', false);
    }
  }

  rowIndex(i: number) {
    if (this.currentPage == 1) {
      return i + 1;
    } else {
      return (this.page_size) * (this.currentPage - 1) + (i + 1);//currentPage start from: 0
    }
  }

  setPage(page: number) {
    this.item_active = 0;
    if (page <= this.totalPage) {
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {

      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning(this.translate.instant('SO_TRANG_TOI_DA_HIEN_TAI_LA') + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      if (page <= this.totalPage) {
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  redirectUpdate() {
    //this.router.navigate(['/evs/store-edit/' + this.item_detail.id])
    this.isAdd = false;
    this.isUpdate = true;
  }


  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  setSort(field: string, typeSort: string) {
    this.currentPage = 1;
    if (this.isSorting['field'] !== field || this.isSorting['typeSort'] !== typeSort) {
      this.isSorting['field'] = field;
      this.isSorting['typeSort'] = typeSort;
      this.loadData(null, { field: field, typeSort: typeSort });
    }
  }

  addStore() {
    this.isAdd = true;
    this.isUpdate = false;
  }

  backToComponent(event) {
    this.isAdd = false;
    this.isUpdate = false;
    if (event.isBack == false) {
      this.currentPage = 1;
      this.loadData(null, this.isSorting);
    }

  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  downloadExcel() {
    let modelQuery = <any>{};
    if (this.model.name) {
      modelQuery.name = this.model.name;
    }
    // let type_value = $('#type').val();
    // if (type_value) {
    //   modelQuery.type = type_value.toString();
    // }
    if ($('#province').val()) {
      let city = $('#province option:selected').text();
      modelQuery.province = city.trim();
    }
    if ($('#district').val()) {
      let district = $('#district option:selected').text();
      modelQuery.district = district.trim();
    }

    let status_value = $('#status').val();
    if (status_value) {
      modelQuery.status = status_value;
    }
    if ($('#staff').val()) {
      let staff = $('#staff option:selected').val();
      modelQuery.created_id = staff.trim();
    }
    if (this.model.created_time) {
      modelQuery.from = moment(this.model.created_time[0]).startOf('day')['_d'];
      modelQuery.to = moment(this.model.created_time[1]).endOf('day')['_d'];
    }
    let url = environment.api_evs + '/g_store/excel?';
    if (modelQuery.name) {
      url += 'name=' + modelQuery.name;
    }
    if (modelQuery.type) {
      url += 'type=' + modelQuery.type;
    }
    if (modelQuery.province) {
      url += '&province=' + modelQuery.province;
    }
    if (modelQuery.district) {
      url += '&district=' + modelQuery.district;
    }
    if (modelQuery.status) {
      url += '&status=' + modelQuery.status;
    }
    if (modelQuery.created_id) {
      url += '&created_id=' + modelQuery.created_id;
    }
    if (modelQuery.from) {
      url += '&from=' + modelQuery.from;
    }
    if (modelQuery.to) {
      url += '&to=' + modelQuery.to;
    }
    url += '&deleted=0';
    url += '&' + this.isSorting.typeSort + '=' + this.isSorting.field;
    if (localStorage.getItem('Access-Token')) {
      url += '&Access_Token=' + localStorage.getItem('Access-Token');
    }
    location.href = url
  }

  /*
    $('#province').val('').trigger('change');
    $('#district').val('').trigger('change');
    this.districts = [];
    $('#type').val('').trigger('change');
    $('#status').val('').trigger('change');
    frm.reset();
    this.onSubmit();
  *
  * */

  filterClick(type, filterForm: NgForm) {
    switch (type) {
      case 'total': {
        this.resetForm(filterForm);
        break;
      }
      case 'total_show': {
        let status = $('#status');
        status.val('').trigger('change');
        filterForm.reset();
        status.val(1).trigger('change');
        this.onSubmit();
        break;
      }
      case 'total_hidden': {
        let status = $('#status');
        status.val('').trigger('change');
        filterForm.reset();
        status.val(0).trigger('change');
        this.onSubmit();
        break;
      }
    }
  }

  /***Tuanba:17-11-2022: Thay api xuất báo cáo **/
  exportReport() {
    console.log('isSorting.typeSort ')
    this.messageExport = '';
    $('.stampBoxStampAlertAdd').css('opacity', '0');
    const modelQuery = <any>{};
    if (this.model.name) {
      modelQuery.name = this.model.name;
    }
    // let type_value = $('#type').val();
    // if (type_value) {
    //   modelQuery.type = type_value.toString();
    // }
    if ($('#province').val()) {
      const city = $('#province').val();
      modelQuery.province = city.trim();
    }
    if ($('#district').val()) {
      const district = $('#district').val();
      modelQuery.district = district.trim();
    }

    const status_value = $('#status').val();
    if (status_value) {
      modelQuery.status = status_value;
    }
    if ($('#staff').val()) {
      const staff = $('#staff option:selected').val();
      modelQuery.created_id = staff.trim();
    }
    if (this.model.created_time) {
      modelQuery.from = moment(this.model.created_time[0]).startOf('day')['_d'];
      modelQuery.to = moment(this.model.created_time[1]).endOf('day')['_d'];
    }
    modelQuery.sort = `created_at,${this.isSorting.typeSort}`
    const body = {
      exportTypeEnum: 'GUARANTEE_STORE',
      fields: modelQuery
    };
    this.exportService.exportReport(body).subscribe((res) => {
      if (res.code == 1) {
        this.messageExport = this.translate.instant('XUAT_FILE_THANH_CONG_VUI_LONG_KIEM_TRA_TRONG_QUAN_LY_BAO_CAO');
        $('.stampBoxStampAlertAdd').css('opacity', '1');
        setTimeout(() => {
          $('.stampBoxStampAlertAdd').css('opacity', '0');
        }, 5000);
      } else {
        $('.stampBoxStampAlertAdd').css('opacity', '0');
        this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/store_manager/store_list.component.ts